// import { Button, Form, InputGroup, Stack } from 'react-bootstrap'
import { Row, Col, InputGroup, Form, Button } from "react-bootstrap";

export default function Pagination(props) {

    const { per_page_default_value, per_page_onChange, left_disabled, left_onClick, currentPage, pageSize, totalRecord, right_disabled, right_onClick } = props

    return (
        <>
            <div className="data_table_footer py-2 px-3 border-top bg-light">
                <Row className="align-items-center gy-2">
                    {/* Spacer / Empty Column */}
                    <Col lg={6} xs={12} className="d-none d-lg-block" />

                    {/* Page Size Selector */}
                    <Col lg={2} sm={6} xs={12}>
                        <InputGroup size="sm">
                            <InputGroup.Text id="inputGroup-sizing-sm">Page Size</InputGroup.Text>
                            <Form.Select
                                className="form_select"
                                defaultValue={per_page_default_value}
                                onChange={per_page_onChange}
                            >
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                                <option value={500}>500</option>
                            </Form.Select>
                        </InputGroup>
                    </Col>

                    {/* Pagination */}
                    <Col lg={4} sm={6} xs={12} className="text-center">
                        <nav aria-label="Page navigation">
                            <ul className="pagination pagination-sm justify-content-center mb-0">
                                <li className="page-item">
                                    <Button
                                        variant="light"
                                        size="sm"
                                        className="page-link"
                                        disabled={left_disabled}
                                        onClick={left_onClick}
                                        style={{
                                            border: "1px solid #dee2e6",
                                            borderTopRightRadius: 0,
                                            borderBottomRightRadius: 0,
                                        }}
                                    >
                                        Previous
                                    </Button>
                                </li>
                                <li className="page-item page-link text-secondary">
                                    {((currentPage * pageSize) + 1) > totalRecord
                                        ? `${totalRecord} - `
                                        : `${(currentPage * pageSize) + 1} - `}
                                    {((currentPage + 1) * pageSize) > totalRecord
                                        ? `${totalRecord} of `
                                        : `${(currentPage + 1) * pageSize} of `}
                                    {totalRecord}
                                </li>
                                <li className="page-item">
                                    <Button
                                        variant="light"
                                        size="sm"
                                        className="page-link"
                                        disabled={right_disabled}
                                        onClick={right_onClick}
                                        style={{
                                            border: "1px solid #dee2e6",
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                        }}
                                    >
                                        Next
                                    </Button>
                                </li>
                            </ul>
                        </nav>
                    </Col>
                </Row>
            </div>
        </>
    )
}